import React, { useRef, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Tooltip } from "src/assets/imports/antdComponents";
import { RootState } from "src/store";

const AxisLabel = ({ title, type, config }) => {
	const { selectedChart } = useSelector((state: RootState) => state.sectionalSummarySlice.sectionalSummary);
	const [visibleCharacters, setVisibleCharacters] = useState(config?.wrap_char_length || 25);
	const labelRef = useRef(null);
	const containerRef = useRef(null);

	// Adjust container class based on axis type
	const containerClass = type === "y" ? "flex justify-center items-center transform -rotate-90 h-full" : "flex justify-center items-center w-full";

	return (
		<div ref={containerRef} className={containerClass}>
			{title?.length > visibleCharacters ? (
				<Tooltip title={title} overlayClassName="quant-tooltip-reduced-padding">
					<span ref={labelRef} className={`text-[11px] text-[${config?.color}] font-semibold overflow-hidden text-ellipsis whitespace-nowrap`}>
						{title?.slice(0, visibleCharacters) + "..."}
					</span>
				</Tooltip>
			) : (
				<span ref={labelRef} className={`text-[11px] text-[${config?.color}] font-semibold overflow-hidden text-ellipsis whitespace-nowrap`}>
					{title}
				</span>
			)}
		</div>
	);
};

export default AxisLabel;

// import React, { useRef, useEffect, useState } from "react";
// import { useSelector } from "react-redux";
// import { Tooltip } from "src/assets/imports/antdComponents";
// import { RootState } from "src/store";

// const AxisLabel = ({ title, type }) => {
// 	const { selectedChart } = useSelector((state: RootState) => state.sectionalSummarySlice.sectionalSummary);
// 	const [visibleCharacters, setVisibleCharacters] = useState(selectedChart ? 35 : 25); // Initial default values
// 	const labelRef = useRef(null);
// 	const containerRef = useRef(null);

// 	useEffect(() => {
// 		if (labelRef.current && containerRef.current && title) {
// 			// Get the container width
// 			const containerWidth = containerRef.current.offsetWidth;

// 			// Create a temporary span to measure text width
// 			const tempSpan = document.createElement("span");
// 			tempSpan.style.visibility = "hidden";
// 			tempSpan.style.position = "absolute";
// 			tempSpan.style.fontSize = "11px";
// 			tempSpan.style.fontFamily = getComputedStyle(labelRef.current).fontFamily;
// 			tempSpan.innerText = title;
// 			document.body.appendChild(tempSpan);

// 			const textWidth = tempSpan.offsetWidth;
// 			document.body.removeChild(tempSpan);

// 			// Calculate how many characters can fit
// 			if (textWidth > containerWidth) {
// 				const charWidth = textWidth / title.length;
// 				// Account for the "..." (approx. 3 chars)
// 				const fittingChars = Math.floor(containerWidth / charWidth - 3);
// 				setVisibleCharacters(Math.max(fittingChars, 10)); // Ensure minimum 10 characters
// 			} else {
// 				// If text fits, show all characters
// 				setVisibleCharacters(title.length);
// 			}
// 		}
// 	}, [title, selectedChart]);

// 	return (
// 		<div ref={containerRef} className={`flex justify-center align-middle ${type === "y" ? "transform -rotate-90" : ""}`}>
// 			{title?.length > visibleCharacters ? (
// 				<Tooltip title={title} overlayClassName="quant-tooltip-reduced-padding">
// 					<span ref={labelRef} className="text-[11px] text-[#5578b0] font-medium overflow-hidden text-ellipsis whitespace-nowrap">
// 						{title?.slice(0, visibleCharacters) + "..."}
// 					</span>
// 				</Tooltip>
// 			) : (
// 				<span ref={labelRef} className="text-[11px] text-[#5578b0] font-medium overflow-hidden text-ellipsis whitespace-nowrap">
// 					{title}
// 				</span>
// 			)}
// 		</div>
// 	);
// };

// export default AxisLabel;

// import React from "react";
// import { useSelector } from "react-redux";
// import { Tooltip } from "src/assets/imports/antdComponents";
// import { RootState } from "src/store";

// const AxisLabel = ({ title, type }) => {
// 	const { selectedChart } = useSelector((state: RootState) => state.sectionalSummarySlice.sectionalSummary);
// 	const characters = selectedChart ? 35 : 25;

// 	return title?.length > characters ? (
// 		<Tooltip title={title} overlayClassName="quant-tooltip-reduced-padding">
// 			<span
// 				className={`flex justify-center align-middle transform ${
// 					type === "y" ? "-rotate-90" : ""
// 				} text-[11px] text-[#5578b0] font-medium overflow-hidden text-ellipsis whitespace-nowrap`}>
// 				{title?.slice(0, characters) + "..."}
// 			</span>
// 		</Tooltip>
// 	) : (
// 		<span
// 			className={`flex justify-center align-middle transform  ${
// 				type === "y" ? "-rotate-90" : ""
// 			} text-[11px] text-[#5578b0] font-medium overflow-hidden text-ellipsis whitespace-nowrap`}>
// 			{title}
// 		</span>
// 	);
// };

// export default AxisLabel;
